import { useEffect, useState } from "react";
import axios from "axios";
import "./uploadDocuments.css";

const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://investor-backend-s4w5.onrender.com");

export default function UploadDocuments({ userId, customerName }) {
  const [files, setFiles] = useState({
    aadhar: null,
    pan: null,
    bankProof: null,
  });

  const [savedDocs, setSavedDocs] = useState({
    aadhar: "",
    pan: "",
    bankProof: "",
  });

  const [form, setForm] = useState({
    fullName: "",
    aadharNumber: "",
    panNumber: "",
    accountNumber: "",
    ifsc: "",
    bankName: "",
  });

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    try {
      if (!userId) return;

      const res = await axios.get(
        `${API_BASE_URL}/api/users/documents/${userId}`,
      );

      setForm({
        fullName: customerName || res.data.name || "",
        aadharNumber: res.data.aadharNumber || "",
        panNumber: res.data.panNumber || "",
        accountNumber: res.data.bankDetails?.accountNumber || "",
        ifsc: res.data.bankDetails?.ifsc || "",
        bankName: res.data.bankDetails?.bankName || "",
      });

      setSavedDocs({
        aadhar: res.data.documents?.aadhar || "",
        pan: res.data.documents?.pan || "",
        bankProof: res.data.documents?.bankProof || "",
      });
    } catch (err) {
      console.log("Load documents error:", err);
    }
  };

  useEffect(() => {
    loadData();
  }, [userId, customerName]);

  const handleFile = (e) => {
    const { name, files: selectedFiles } = e.target;

    setFiles((prev) => ({
      ...prev,
      [name]: selectedFiles?.[0] || null,
    }));
  };

  const upload = async () => {
    if (!userId) {
      alert("User ID missing ❌");
      return;
    }

    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      formData.append(key, form[key] || "");
    });

    if (files.aadhar) formData.append("aadhar", files.aadhar);
    if (files.pan) formData.append("pan", files.pan);
    if (files.bankProof) formData.append("bankProof", files.bankProof);

    try {
      setLoading(true);

      const res = await axios.post(
        `${API_BASE_URL}/api/users/upload-docs/${userId}`,
        formData,
      );

      alert("Saved Successfully ✅");

      setFiles({
        aadhar: null,
        pan: null,
        bankProof: null,
      });

      await loadData();
    } catch (err) {
      console.log("Upload failed:", err);
      alert(err?.response?.data?.msg || "Upload failed ❌");
    } finally {
      setLoading(false);
    }
  };

  const openFile = (fileName) => {
    if (!fileName) return;
    window.open(`${API_BASE_URL}/uploads/${fileName}`, "_blank");
  };

  const getDisplayName = (fileName) => {
    if (!fileName) return "";
    const parts = fileName.split("-");
    return parts.slice(2).join("-") || fileName;
  };

  return (
    <div className="upload-container">
      <h2>Upload Documents & Details</h2>

      <div className="upload-card">
        {/* MAIN FLEX */}
        <div className="main-flex">
          {/* LEFT SIDE FORM */}
          <div className="left-form">
            <div className="grid">
              <div className="form-group">
                <label>Full Name</label>
                <input
                  value={form.fullName}
                  onChange={(e) =>
                    setForm({ ...form, fullName: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label>Aadhar Number</label>
                <input
                  value={form.aadharNumber}
                  onChange={(e) =>
                    setForm({ ...form, aadharNumber: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label>PAN Number</label>
                <input
                  value={form.panNumber}
                  onChange={(e) =>
                    setForm({ ...form, panNumber: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label>Account Number</label>
                <input
                  value={form.accountNumber}
                  onChange={(e) =>
                    setForm({ ...form, accountNumber: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label>IFSC Code</label>
                <input
                  value={form.ifsc}
                  onChange={(e) => setForm({ ...form, ifsc: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>Bank Name</label>
                <input
                  value={form.bankName}
                  onChange={(e) =>
                    setForm({ ...form, bankName: e.target.value })
                  }
                />
              </div>
            </div>
          </div>

          {/* RIGHT SIDE FILE UPLOAD */}
          <div className="right-docs">
            {/* AADHAR */}
            <div className="file-row">
              <label>Aadhar</label>
              <input type="file" name="aadhar" onChange={handleFile} />

              {files.aadhar ? (
                <span>{files.aadhar.name}</span>
              ) : savedDocs.aadhar ? (
                <span>
                  {getDisplayName(savedDocs.aadhar)}
                  <button onClick={() => openFile(savedDocs.aadhar)}>
                    View
                  </button>
                </span>
              ) : (
                <span>No file</span>
              )}
            </div>

            {/* PAN */}
            <div className="file-row">
              <label>PAN</label>
              <input type="file" name="pan" onChange={handleFile} />

              {files.pan ? (
                <span>{files.pan.name}</span>
              ) : savedDocs.pan ? (
                <span>
                  {getDisplayName(savedDocs.pan)}
                  <button onClick={() => openFile(savedDocs.pan)}>View</button>
                </span>
              ) : (
                <span>No file</span>
              )}
            </div>

            {/* BANK */}
            <div className="file-row">
              <label>Bank Proof</label>
              <input type="file" name="bankProof" onChange={handleFile} />

              {files.bankProof ? (
                <span>{files.bankProof.name}</span>
              ) : savedDocs.bankProof ? (
                <span>
                  {getDisplayName(savedDocs.bankProof)}
                  <button onClick={() => openFile(savedDocs.bankProof)}>
                    View
                  </button>
                </span>
              ) : (
                <span>No file</span>
              )}
            </div>
          </div>
        </div>

        {/* BUTTON */}
        <button className="save-btn" onClick={upload} disabled={loading}>
          {loading ? "Saving..." : "Save All"}
        </button>
      </div>
    </div>
  );
}
